import React from 'react';

const ROWS = [
  ['Produção', 'Coutin Studio'],
  ['Local', 'Na sua empresa. A gente leva tudo.'],
  ['Equipe', 'Captação · Iluminação · Edição'],
  ['Equipamento', 'Câmeras · Lentes · Softbox · Iluminação · Áudio · Drone'],
  ['Entrega', 'Editado e pronto para postar'],
  ['Também', 'Gestão do Instagram · Sites · Landing Pages'],
];

export const FichaTecnica = () => (
  <div className="sh-clap-wrap" data-testid="ficha-tecnica">
    <div className="sh-clap sh-clap-top" />
    <div className="sh-clap" />
    <dl className="border-2 border-t-0 border-[#F2F2EE]/80 bg-[#0A0B0B]/85 backdrop-blur-sm">
      {ROWS.map(([label, value], i) => (
        <div
          key={label}
          className={`grid grid-cols-[110px_1fr] sm:grid-cols-[170px_1fr] items-center px-4 sm:px-6 py-3 ${i ? 'border-t border-white/10' : ''}`}
        >
          <dt className="sh-mono text-[10px] sm:text-xs text-[var(--sh-teal)]">{label}</dt>
          <dd className="font-semibold text-sm sm:text-lg leading-snug">{value}</dd>
        </div>
      ))}
    </dl>
  </div>
);
